import { NotificationActionTypes, NotificationState } from './notificationTypes';

const INIT_STATE: NotificationState = {
  items: [],
};

const notificationReducer = (state = INIT_STATE, action: any): NotificationState => {
  switch (action.type) {
    case NotificationActionTypes.PUSH:
      return { items: [...state.items, action.payload] };
    case NotificationActionTypes.DISMISS:
      return { items: state.items.filter(n => n.id !== action.payload.id) };
    case NotificationActionTypes.CLEAR:
      return INIT_STATE;
    default:
      return state;
  }
};

export default notificationReducer;
